import { render } from "./PlatformStats.vue?vue&type=template&id=46f0d06a"
import script from "./PlatformStats.vue?vue&type=script&lang=js"
export * from "./PlatformStats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__